import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CaptionLabelComponent } from './caption-label.component';

@NgModule({
  declarations: [CaptionLabelComponent],
  exports: [CaptionLabelComponent],
  imports: [CommonModule],
})
export class CaptionLabelModule {}
